/**
 * Configuración para optimización de imágenes
 * Centraliza la configuración de formatos, tamaños y breakpoints
 * para el componente Image y otros componentes relacionados
 */

export const imageConfig = {
  // Formato de salida preferido para imágenes optimizadas
  'image-output-format': 'avif',

  // Tamaños de imagen disponibles para generar srcset
  'extra-images': [
    50, // xs - Para iconos y elementos muy pequeños
    400, // s  - Para móviles pequeños
    800, // m  - Para móviles grandes y tablets
    1280, // l  - Para desktop y pantallas grandes
  ],

  // Configuración de sizes para diferentes breakpoints
  sizes: {
    mobile: '100vw',
    tablet: '100vw',
    desktop: '800px',
  },

  // Breakpoints para media queries
  breakpoints: {
    tablet: '768px',
    desktop: '1024px',
  },

  // Configuración adicional para futuras extensiones
  // Por ejemplo: metadatos, formatos adicionales, etc.
};
